import { TextProps } from 'antd/lib/typography/Text';
import { Text as TextComponent } from 'components';
import { theme } from 'configs/styled';
import React from 'react';

export interface ITextLRegularProps extends TextProps {
  fontSize?: string;
  color?: string;
  display?: string;
  margin?: string;
}

const TextRegular: React.FC<ITextLRegularProps> = ({
  fontSize = theme.fontSize.xs,
  color = theme.palettes.black45,
  display = 'inline',
  margin = '0px',
  ...props
}) => {
  return (
    <TextComponent
      {...props}
      style={{
        fontWeight: theme.fontWeight.regular,
        fontStyle: 'normal',
        fontSize,
        lineHeight: '22px',
        color,
        display,
        margin,
      }}
    />
  );
};

export default TextRegular;
